module.exports = __webpack_public_path__ + "static/wsu-scan.e9a07125.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/wsu-library/wsu-scan.jpg
// module id = 482
// module chunks = 262546004982204